import type {GTAGItem} from "../@types/gtagTypes";
import type {ServerProduct as ProductType} from "../@types/product";

export function createGTagEventObj(props: {products: ProductType[], ids: string[], siteCategoryID?: string, position?: number , currentCategoryName?: string, original_search_query?: string, listTitle?: string}): GTAGItem[] {
    const createSingleItem = (product: ProductType, pos: number) => {
        return {
            item_list_id: props.siteCategoryID || "",
            item_list_name: `Fast Simon ${props?.currentCategoryName ? ('Collection: ' + props.currentCategoryName) : (props?.original_search_query ? ('Search: ' + props?.original_search_query): (props?.listTitle??''))}`,
            item_id: String(product?.id),
            item_name: product.l,
            item_brand: product.v,
            currency: product.c,
            index: props?.position !== undefined? props?.position : pos,
            price: Number(product.p)
        }
    }
    const items: GTAGItem[] = [];
    props.ids.forEach((id, index) => items.push(createSingleItem(props.products[index], index+1)));
    return items;
}